module.exports = __webpack_public_path__ + "static/media/AI.94393762.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AI.svg
// module id = 2097
// module chunks = 7